import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { KaraokeProvider } from "./store/KaraokeStore";
import Console from "./pages/Console";
import SecondScreen from "./pages/SecondScreen";
import Guest from "./pages/Guest";

const TOAST_OPTIONS = {
  style: {
    background: "#0F0F0F",
    border: "1px solid #262626",
    color: "#fff",
    fontFamily: "Manrope, sans-serif",
  },
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <KaraokeProvider>
          <Routes>
            <Route path="/" element={<Console />} />
            <Route path="/player" element={<SecondScreen />} />
            <Route path="/guest" element={<Guest />} />
          </Routes>
          <Toaster
            position="top-center"
            theme="dark"
            toastOptions={TOAST_OPTIONS}
          />
        </KaraokeProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
